<template>
  <div class="mask" @click="isShow = false" v-if="isShow">
    <div class="popup-section" :style="{ left: offsetLeft + 'px' }" @click.stop>
      <div class="tabs-nav">
        <div class="tab-item" @click.stop="tabChange(0)">
          <img src="@/imgs/user/icon-16.png" class="icon" v-if="tabActive == 0" />
          <img src="@/imgs/user/icon-19.png" class="icon" v-else />
          <span class="tab-title" :class="{ active_tab: tabActive == 0 }">{{
            $t("通知")
          }}</span>
        </div>
        <div class="tab-item" @click.stop="tabChange(1)">
          <img src="@/imgs/user/icon-18.png" class="icon" v-if="tabActive == 1" />
          <img src="@/imgs/user/icon-15.png" class="icon" v-else />
          <span class="tab-title" :class="{ active_tab: tabActive == 1 }">{{
            $t("评论")
          }}</span>
        </div>
        <div class="tab-item" @click.stop="tabChange(2)">
          <img src="@/imgs/user/icon-17.png" class="icon" v-if="tabActive == 2" />
          <img src="@/imgs/user/icon-14.png" class="icon" v-else />
          <span class="tab-title" :class="{ active_tab: tabActive == 2 }">{{
            $t("关注")
          }}</span>
        </div>
        <div class="tab-item" @click.stop="tabChange(3)">
          <img src="@/imgs/user/icon-20.png" class="icon" v-if="tabActive == 3" />
          <img src="@/imgs/user/icon-13.png" class="icon" v-else />
          <span class="tab-title" :class="{ active_tab: tabActive == 3 }">{{
            $t("收藏")
          }}</span>
        </div>
      </div>
      <div class="notice-section" v-if="tabActive == 0">
        <div v-if="tz_total != 0">
          <ul class="notice-ul" @scroll="scrollSc">
            <li class="notice-li" v-for="(item, index) in tz_list" :key="index">
              <div class="content">
                <span class="c-999">{{ $t("平台发布了通知") }}</span>
                <span>{{ item.title }}</span>
              </div>
              <div class="date">{{ item.create_time }}</div>
            </li>
          </ul>
          <div class="bottom pointer" @click="toAll(1)">{{ $t("查看全部通知") }}</div>
        </div>
        <div class="empty" v-if="tz_total == 0">{{ $t("暂无数据") }}</div>
      </div>
      <div v-if="tabActive == 1">
        <div v-if="pl_total != 0">
          <ul class="notice-ul">
            <li class="notice-li" v-for="(item, index) in pl_list" :key="index">
              <div class="content">
                <span class="c-559aff">{{ item.user_nickname }}</span>
                <span class="c-999">{{ $t("回复您：") }}</span>
                <span>{{ item.content }}</span>
              </div>
              <div class="date">{{ item.create_time }}</div>
            </li>
          </ul>
          <div class="bottom pointer" @click="toAll(2)">{{ $t("查看全部评论") }}</div>
        </div>
        <div class="empty" v-if="pl_total == 0">{{ $t("暂无数据") }}</div>
      </div>
      <div v-if="tabActive == 2">
        <div v-if="gz_total != 0">
          <ul class="notice-ul">
            <li class="notice-li" v-for="(item, index) in gz_list" :key="index">
              <div class="content">
                <span class="c-559aff">{{ item.user_nickname }} ：</span>
                <span class="c-999">{{ $t("关注了你") }}</span>
              </div>
              <div class="date">{{ item.create_time }}</div>
            </li>
          </ul>
          <div class="bottom pointer" @click="toAll(3)">{{ $t("查看全部关注") }}</div>
        </div>
        <div class="empty" v-if="gz_total == 0">{{ $t("暂无数据") }}</div>
      </div>
      <div v-if="tabActive == 3">
        <div v-if="sc_list.length != 0">
          <ul class="notice-ul">
            <li class="notice-li" v-for="(item, index) in sc_list" :key="index">
              <div class="content">
                <span class="c-559aff">{{ item.user_nickname }} ：</span>
                <span class="c-999">{{ item.tip }}</span>
                <span>{{ item.title }}</span>
              </div>
              <div class="date">{{ item.create_time }}</div>
            </li>
          </ul>
          <div class="bottom pointer" @click="toAll(4)">{{ $t("查看全部收藏") }}</div>
        </div>
        <div class="empty" v-if="sc_list.length == 0">{{ $t("暂无数据") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/request1";
export default {
  props: {
    // 距离左边距离
    left: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      isShow: false,
      tabActive: 0,
      sc_list: [],
      sc_total: 0,
      gz_list: [],
      gz_total: 0,
      pl_list: [],
      pl_total: 0,
      tz_list: [],
      tz_total: 0,
    };
  },
  computed: {
    offsetLeft() {
      return this.left - 152;
    },
    isLogin() {
      let token = localStorage.getItem("USER_TOKEN") || "";
      return token ? true : false;
    },
  },
  mounted() {
    if (this.tabActive == 0) {
      this.getTzList();
    } else if (this.tabActive == 1) {
      this.getPlList();
    } else if (this.tabActive == 2) {
      this.getGzList();
    } else if (this.tabActive == 3) {
      this.getScList();
    }
  },
  methods: {
    hidden() {
      this.isShow = false;
    },
    toAll(type) {
      this.isShow = false;
      this.$router.push({
        path: "/transition",
        query: {
          type,
        },
      });
    },
    show() {
      this.isShow = true;
    },
    tabChange(e) {
      this.tabActive = e;
      if (e == 0) {
        this.getTzList();
      } else if (e == 1) {
        this.getPlList();
      } else if (e == 2) {
        this.getGzList();
      } else if (e == 3) {
        this.getScList();
      }
    },
    getScList() {
      if (this.isLogin) {
        api.post62bd520a69f54().then((res) => {
          if (res.code != 1) {
            this.$message.error(res.msg);
            return;
          }
          let data = res.data.data;
          let list = [];
          data.forEach((item) => {
            if (item.thumb != "") {
              list.push(item);
            }
          });
          this.sc_list = list;
          this.sc_total = res.data.total;
        });
      }
    },
    getGzList() {
      if (this.isLogin) {
        api
          .post62bd550b6d8df({
            list_rows: 2,
          })
          .then((res) => {
            if (res.code != 1) {
              this.$message.error(res.msg);
              return;
            }
            this.gz_list = res.data.data;
            this.gz_total = res.data.total;
          });
      }
    },
    getPlList() {
      if (this.isLogin) {
        api.post62bd5342a3a8e().then((res) => {
          if (res.code != 1) {
            this.$message.error(res.msg);
            return;
          }
          this.pl_list = res.data.data;
          this.pl_total = res.data.total;
        });
      }
    },
    getTzList() {
      if (this.isLogin) {
        api.post618a38c0ca95f().then((res) => {
          if (res.code != 1) {
            this.$message.error(res.msg);
            return;
          }
          this.tz_list = res.data.data;
          this.tz_total = res.data.total;
        });
      }
    },
    scrollSc() {},
  },
};
</script>

<style lang="scss" scoped>
@import "themePath/notice";
.empty {
  padding: 50px 0;
  text-align: center;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/noticePopup.vue